import { motion } from "motion/react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const sections = [
  {
    id: "01",
    title: "개인정보의 수집 및 이용 목적",
    content: `강스터디(이하 '회사')는 다음과 같은 목적으로 개인정보를 수집 및 이용합니다. 수집된 개인정보는 아래 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경될 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

① 서비스 제공: 부동산 경매 교육 콘텐츠 제공, 강의 신청 및 수강 관리, 상담 서비스 제공, 경매 데이터 분석 서비스 제공
② 회원 관리: 회원제 서비스 이용에 따른 본인 확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령 확인, 불만처리 등 민원처리, 고지사항 전달
③ 마케팅 및 광고에 활용: 신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계`,
  },
  {
    id: "02",
    title: "수집하는 개인정보 항목",
    content: `회사는 서비스 이용을 위해 아래와 같은 개인정보를 수집하고 있습니다.

① 필수 수집 항목
- 회원가입 시: 이름, 이메일 주소, 비밀번호, 휴대폰 번호
- 상담 신청 시: 이름, 연락처, 이메일 주소, 상담 희망 일시, 상담 내용
- 유료 서비스 이용 시: 이름, 연락처, 이메일 주소, 결제 정보(카드사명, 카드번호 일부)

② 서비스 이용 과정에서 자동 생성되는 정보
- IP 주소, 쿠키, 방문 일시, 서비스 이용 기록, 기기 정보, 브라우저 유형

③ 선택 수집 항목
- 마케팅 정보 수신 동의: 이메일, 휴대폰 번호
- 프로필 정보: 프로필 사진, 자기소개, 관심 경매 지역`,
  },
  {
    id: "03",
    title: "개인정보의 보유 및 이용 기간",
    content: `회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관련 법령에 따라 일정 기간 보존이 필요한 경우에는 해당 기간 동안 보존합니다.

① 회원 정보: 회원 탈퇴 시까지
② 상담 신청 정보: 상담 완료 후 1년
③ 유료 서비스 결제 정보: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
④ 서비스 이용 기록 및 접속 로그: 3개월 (통신비밀보호법)
⑤ 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
⑥ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)`,
  },
  {
    id: "04",
    title: "개인정보의 파기 절차 및 방법",
    content: `회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.

① 파기 절차: 이용자가 입력한 정보는 목적 달성 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 따라 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.

② 파기 방법:
- 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.`,
  },
  {
    id: "05",
    title: "개인정보의 제3자 제공",
    content: `회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.

① 이용자가 사전에 동의한 경우
② 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않으며, 제3자 제공이 필요한 경우 이용자에게 사전에 개별적으로 고지하고 동의를 받습니다.`,
  },
  {
    id: "06",
    title: "개인정보 처리의 위탁",
    content: `회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리 업무를 외부 전문업체에 위탁하고 있습니다.

① 수탁업체 및 위탁 업무 내용
- 카카오페이, 네이버페이: 결제 서비스 대행
- Amazon Web Services (AWS): 서비스 제공을 위한 인프라 관리 및 데이터 보관
- Supabase: 데이터베이스 호스팅 및 관리

② 위탁 계약 시 개인정보보호 관련 법규의 준수, 개인정보에 관한 비밀유지, 제3자 제공 금지, 사고 시 책임 부담, 위탁 기간, 처리 종료 후 개인정보의 반환 또는 파기 의무 등을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.`,
  },
  {
    id: "07",
    title: "정보주체의 권리 및 행사 방법",
    content: `이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.

① 개인정보 열람 요구: 회사가 보유하고 있는 자신의 개인정보에 대한 열람을 요청할 수 있습니다.
② 개인정보 정정·삭제 요구: 자신의 개인정보에 오류가 있을 경우 정정을 요청할 수 있으며, 불필요한 개인정보의 삭제를 요청할 수 있습니다.
③ 개인정보 처리 정지 요구: 개인정보 처리의 정지를 요청할 수 있습니다.

권리 행사는 마이페이지 내 '개인정보 설정' 메뉴를 통해 직접 하실 수 있으며, 또는 개인정보보호 책임자에게 서면, 전화, 이메일로 연락하시면 지체 없이 조치하겠습니다.

이용자가 개인정보 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용하거나 제공하지 않습니다.`,
  },
  {
    id: "08",
    title: "개인정보 자동 수집 장치의 설치·운영 및 거부",
    content: `회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 쿠키(cookie)를 사용합니다. 쿠키는 웹사이트를 운영하는 데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.

① 쿠키의 사용 목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.

② 쿠키의 설치·운영 및 거부: 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.

③ 쿠키 설정 거부 방법: 이용자는 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 쿠키 저장을 거부할 경우 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.`,
  },
  {
    id: "09",
    title: "개인정보 보호책임자",
    content: `회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
- 성명: 강승만
- 직책: 대표이사
- 이메일: kangstudy@naver.com
- 전화번호: 010-8262-0188

이용자는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 회사는 이용자의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.`,
  },
  {
    id: "10",
    title: "개인정보의 안전성 확보 조치",
    content: `회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적·관리적·물리적 조치를 하고 있습니다.

① 기술적 조치
- 개인정보 암호화 전송(SSL/TLS 적용)
- 개인정보 저장 시 암호화 적용
- 해킹 및 바이러스 방지를 위한 보안 프로그램 설치 및 주기적 업데이트
- 접근 통제 시스템 운영

② 관리적 조치
- 개인정보 취급 직원의 최소화 및 정기적 교육 실시
- 개인정보보호 내부관리계획 수립 및 시행
- 개인정보 취급자에 대한 정기적 접근 권한 점검

③ 물리적 조치
- 개인정보 보관 시설의 접근 통제 및 잠금 장치 설치
- 서버실 및 자료 보관실 출입 통제`,
  },
  {
    id: "11",
    title: "권익침해 구제 방법",
    content: `이용자는 개인정보 침해로 인한 구제를 받기 위하여 아래 기관에 분쟁 해결이나 상담 등을 신청할 수 있습니다.

① 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)
② 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)
③ 대검찰청 사이버수사과: (국번없이) 1301 (www.spo.go.kr)
④ 경찰청 사이버안전국: (국번없이) 182 (ecrm.cyber.go.kr)

회사는 정보주체의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 노력하고 있습니다. 개인정보와 관련한 문의나 불만이 있으신 분은 개인정보 보호책임자에게 연락하여 주시기 바랍니다.`,
  },
  {
    id: "12",
    title: "개인정보처리방침 변경",
    content: `이 개인정보처리방침은 2026년 8월 6일부터 적용됩니다. 법령, 정책 또는 보안 기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 최소 7일 전에 회사 웹사이트를 통해 변경 이유 및 내용 등을 공지하도록 하겠습니다.

① 공고 일자: 2026년 8월 6일
② 시행 일자: 2026년 8월 6일`,
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06 },
  },
};

const sectionItem = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" as const } },
};

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] font-['Noto_Sans_KR']">
      <Navbar />
      <main className="pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-[860px] mx-auto">
          {/* Page Header */}
          <motion.div
            className="mb-12 text-center"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" as const }}
          >
            <div className="flex items-center justify-center gap-2 mb-3">
              <i className="ri-shield-check-line text-[#C4956A]"></i>
              <span className="text-xs font-medium text-[#C4956A]">Privacy Policy</span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-3">
              개인정보처리방침
            </h1>
            <p className="text-sm text-[#8C8780] max-w-[500px] mx-auto leading-relaxed">
              강스터디는 이용자의 개인정보를 소중히 취급하며, 관련 법령을 준수하고 있습니다.
              본 방침은 2026년 8월 6일부터 시행됩니다.
            </p>
          </motion.div>

          {/* Last Updated Badge */}
          <motion.div
            className="flex items-center justify-center gap-2 mb-10"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-white border border-[#E8E5E0] rounded-full text-xs text-[#8C8780]">
              <i className="ri-calendar-line text-[#C4956A]"></i>
              최종 업데이트: 2026년 8월 6일
            </span>
          </motion.div>

          {/* Table of Contents */}
          <motion.div
            className="bg-white rounded-xl border border-[#E8E5E0] p-6 md:p-8 mb-10"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.4 }}
          >
            <h2 className="text-sm font-semibold text-[#1C1917] mb-4 flex items-center gap-2">
              <i className="ri-list-unordered text-[#C4956A]"></i>
              목차
            </h2>
            <nav className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
              {sections.map((s) => (
                <a
                  key={s.id}
                  href={`#section-${s.id}`}
                  className="flex items-center gap-2 px-3 py-2 text-sm text-[#5C5650] hover:text-[#C4956A] hover:bg-[#FAF8F6] rounded-md transition-colors"
                >
                  <span className="text-xs font-medium text-[#C4956A] w-5">{s.id}</span>
                  {s.title}
                </a>
              ))}
            </nav>
          </motion.div>

          {/* Policy Sections */}
          <motion.div
            className="space-y-6"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
          >
            {sections.map((section) => (
              <motion.section
                key={section.id}
                id={`section-${section.id}`}
                variants={sectionItem}
                className="bg-white rounded-xl border border-[#E8E5E0] p-6 md:p-8 scroll-mt-28"
              >
                <div className="flex items-start gap-4 mb-4">
                  <span className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#C4956A]/10 flex items-center justify-center">
                    <span className="text-sm font-bold text-[#C4956A]">{section.id}</span>
                  </span>
                  <h2 className="text-lg font-bold text-[#1C1917] leading-tight pt-1.5">
                    {section.title}
                  </h2>
                </div>
                <div className="text-sm text-[#5C5650] leading-relaxed whitespace-pre-line space-y-3 pl-14">
                  {section.content.split("\n\n").map((paragraph, pIdx) => (
                    <p key={pIdx}>{paragraph}</p>
                  ))}
                </div>
              </motion.section>
            ))}
          </motion.div>

          {/* Bottom CTA */}
          <motion.div
            className="mt-12 bg-[#1C1917] rounded-2xl p-8 md:p-10 text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-white/10 flex items-center justify-center">
              <i className="ri-mail-line text-xl text-[#C4956A]"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">
              개인정보 관련 문의
            </h3>
            <p className="text-sm text-[#B8B3AE] mb-6 max-w-[480px] mx-auto leading-relaxed">
              개인정보처리방침에 관한 궁금한 점이나 개인정보 관련 문의사항이 있으시면 언제든지 아래 연락처로 문의해 주세요.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-[#B8B3AE]">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-[#C4956A]"></i>
                kangstudy@naver.com
              </span>
              <span className="hidden sm:block text-[#3D3935]">|</span>
              <span className="flex items-center gap-2">
                <i className="ri-phone-line text-[#C4956A]"></i>
                010-8262-0188
              </span>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}